module.exports = __webpack_public_path__ + "img/electric_no_zone.dfc0f0df.svg";